import React, { useEffect } from 'react';

export default function RecaptchaScriptLoader(props) {

    const scriptId = 'google-recaptcha-v3';
    const googleRecaptchaSrc = 'https://www.google.com/recaptcha/api.js';

    useEffect(() => {
        const loadScriptByURL = (id, url, callback) => {
            const isScriptExist = document.getElementById(id);

            if (!isScriptExist) {
                var script = document.createElement("script");
                script.type = "text/javascript";
                script.src = url;
                script.id = id;
                script.onload = function () {
                    if (callback) callback();
                };
                document.body.appendChild(script);
            }

            if (isScriptExist && callback) callback();
        }

        // load the script by passing the URL
        loadScriptByURL(scriptId, `https://www.google.com/recaptcha/api.js?render=${props.sitekey}`, function () {
            console.log("Recapctha script loaded!");
        });
    }, []);

    return null;

}